export interface IFavoriteChamp {
  id: number;
  title: string;
  sportId: number;
  sportAlias: string;
  eventsCount: number;
}

export interface IFavoriteTeam {
  id: number;
  title: string;
}

export interface IFavoriteEvent {
  id: number;
  host: string;
  guest: string;
  date: number;
  champId: number;
  sportId: number;
}

export interface IFavoritesList {
  champs: IFavoriteChamp[];
  teams: IFavoriteTeam[];
  events: IFavoriteEvent[];
}

export interface IFavoriteSearchItem {
  id: number;
  title: string;
  sportId?: number;
  eventsCount?: number;
}

type IRow = Record<string, unknown>;

const rows = (value: unknown): IRow[] => (Array.isArray(value) ? value.filter((row) => row && typeof row === 'object') as IRow[] : []);
const text = (value: unknown) => (typeof value === 'string' ? value : value === null || value === undefined ? '' : String(value));

export function toFavoritesList(response: unknown): IFavoritesList {
  const raw = (response && typeof response === 'object' ? response : {}) as IRow;
  return {
    champs: rows(raw.champs).map((row) => ({
      id: Number(row.id),
      title: text(row.title),
      sportId: Number(row.sportId) || 0,
      sportAlias: text(row.sportAlias),
      eventsCount: Number(row.eventsCount) || 0,
    })).filter((row) => row.id > 0),
    teams: rows(raw.teams).map((row) => ({ id: Number(row.id), title: text(row.title) })).filter((row) => row.id > 0),
    events: rows(raw.events).map((row) => ({
      id: Number(row.id),
      host: text(row.host),
      guest: text(row.guest),
      date: Number(row.date) || 0,
      champId: Number(row.champId) || 0,
      sportId: Number(row.sportId) || 0,
    })).filter((row) => row.id > 0),
  };
}

export function toFavoriteSearch(response: unknown): IFavoriteSearchItem[] {
  return rows(response).map((row) => ({
    id: Number(row.id),
    title: text(row.title),
    ...(row.sportId !== undefined ? { sportId: Number(row.sportId) } : {}),
    ...(row.eventsCount !== undefined ? { eventsCount: Number(row.eventsCount) } : {}),
  })).filter((row) => row.id > 0);
}
